export const ERR_TITLE_GENERAL = 'error.title.general';
export const ERR_MSG_GENERAL = 'error.message.general';
export const ERR_TITLE_NOT_AUTH = 'error.title.upgrade_not_authorized';
export const ERR_MSG_NOT_AUTH = 'error.message.upgrade_not_authorized';
export const ERR_NOT_AUTH = `${ERR_TITLE_NOT_AUTH}${ERR_MSG_NOT_AUTH}`;
export const ERR_GENERAL = `${ERR_TITLE_GENERAL}${ERR_MSG_GENERAL}`;

export const TECH_ERRORS = {
  MISSING_MSID: 'Missing metaSiteId in query param.',
  PRODUCT_NOT_FOUND: 'Product ID not found-',
  CLIENT_OFFERING_NEED_DEFAULT: 'Client offering needs default.',
  SITE_DETAIL_CALL_FAILED: 'site-detail service call failed - ',
  PREMIUM_OFFER_CALL_FAILED: 'premium-offering service call failed - ',
  USER_DATA_FETCH_FALILED: 'Failed to fetch user data.',
};

export const PACKAGE_NAMES = {
  FREE: 'free',
  BASIC: 'basic',
  PROFESSIONAL: 'professional',
  UNLIMITED: 'unlimited',
};

export const PACKAGE_IDS = {
  BASIC_LEGACY: '588aa405-d199-4509-afb4-a11621984be6',
  PROFESSIONAL_LEGACY: 'bcbc441f-47da-4735-b58f-e5386647bf5f',
  UNLIMITED_LEGACY: '1f3d81c2-2743-4402-96a9-66c71d7690b0',
  BRAZIL_BASIC: '2aad0a35-c80a-4797-9815-8ae9453151ee',
  BRAZIL_PROFESSIONAL: 'f1425e14-ee48-4adf-a2d6-2d226f1784dd',
  BRAZIL_UNLIMITED: '3ff82981-e2a9-46d8-9b3c-ba2d5f5706f4',
  BASIC: '1118962b-15a4-4a73-ad8a-ee7a2eac3103',
  PROFESSIONAL: '4c688dee-f835-4022-8fc9-bc8ae7ae2fa7',
  UNLIMITED: '3cd2a53b-da6d-4c86-94a9-ad5da1f45c99',
};

export const MAP_PRODUCT_ID_TO_SOCIAL_POSTS = {
  [PACKAGE_IDS.BASIC_LEGACY]: '5',
  [PACKAGE_IDS.BRAZIL_BASIC]: '5',
  [PACKAGE_IDS.BASIC]: '5',
  [PACKAGE_IDS.PROFESSIONAL_LEGACY]: '20',
  [PACKAGE_IDS.PROFESSIONAL]: '20',
  [PACKAGE_IDS.BRAZIL_PROFESSIONAL]: '20',
  [PACKAGE_IDS.UNLIMITED_LEGACY]: '__UNLIMITED__',
  [PACKAGE_IDS.UNLIMITED]: '__UNLIMITED__',
  [PACKAGE_IDS.BRAZIL_UNLIMITED]: '__UNLIMITED__',
};

export const FEATURES = 'features.';
export const FEATURES_INFO = 'featuresInfo.';

export const UNLIMITED_STRING = '__UNLIMITED__';

export const PRODUCT_LIMITATION_LIMITED_LEGACY = {
  emailsCampaignsMonth: '3',
  emailsSendMonth: '3',
  formsMonth: '5',
  automations: '2',
  socialPosts: '3',
  videoCreation: '4',
  paymentRecurring: '5',
  siteContributors: '',
  UNLIMITED: UNLIMITED_STRING,
};

export const PRODUCT_LIMITATION_LIMITED = {
  emailsCampaignsMonth: '200',
  emailsSendMonth: '200',
  formsMonth: '5',
  automations: '2',
  socialPosts: '3',
  videoCreation: '4',
  paymentRecurring: '5',
  siteContributors: '',
  UNLIMITED: UNLIMITED_STRING,
};

export const CURRENCY_ON_RIGHT = ['de', 'fr'];

export const formatNumber = (
  num: number,
  decimalSeparator: string,
  groupSeparator: string,
) => {
  let formatted = (num ?? 0).toString();
  if (decimalSeparator !== '.') {
    formatted = formatted.replace('.', decimalSeparator);
  }
  return formatted.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${groupSeparator}`);
};

export const BI_SOURCE = 5;
export const VIDEO_MAKER_BENEFIT_KEY = '2';
